const projectData = [
    
    
    {
        title: "Re-you Projesi ",
        description: [
            "Bu proje kapsamında Articulete Storyline 360 programı ile etkile¸simli eğitimi içerikleri geliştirdim.",
            "Daha sonrasında bu içerikleri scrom paketi halinde çıktılarını alıp kurduğumuz LMS sistemine yüklemesini" +
            "yaptım. Ayrıca bu proje Avrupa birliği onaylıdır."
        ]
    },

    {
        title: "Digiessa4schools Projesi",
        description: [
            "Katıldığım toplantılarda ihtiyaca göre önce bir web sitesi arayüzü tasarladım. Sonrasında onay aldıktan" +
            "sonra WordPress ile kurulumunu gerçekleştirdim." 
        ]
    }
]

export default projectData;